import { render, staticRenderFns } from "./SkillForm.vue?vue&type=template&id=2222f80b&scoped=true&"
import script from "./SkillForm.vue?vue&type=script&lang=js&"
export * from "./SkillForm.vue?vue&type=script&lang=js&"
import style0 from "./SkillForm.vue?vue&type=style&index=0&id=2222f80b&prod&lang=css&"
import style1 from "./SkillForm.vue?vue&type=style&index=1&id=2222f80b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222f80b",
  null
  
)

export default component.exports